export function averageRounded(values: number[]) {
	return Math.round(
		values.reduce((sum, it) => sum + it, 0) / (values.length || 1),
	)
}
